<app-navigation></app-navigation>

<div class="container p-4">
    <router-outlet></router-outlet>
</div>